export const PUBLIC_ROUTE_PREFIXES = [
  '/market',
  '/esign/sign',
];

export const isPublicRoute = (path) => {
  return PUBLIC_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix));
};

